export function formatPrice(price: string | null = '') {
  if (price?.includes('-')) {
    return price?.replace('-', ' - ');
  }
  return price ?? '';
}
